import { ReactNode } from 'react';

import { clsx } from 'clsx';

import cls from './Chip.module.scss';

type ChipProps = {
  onClick?: () => void;
  active?: boolean;
  label?: ReactNode;
};

export const Chip = ({ onClick, active, label }: ChipProps) => {
  return (
    <div
      onClick={onClick}
      className={clsx(cls.wrap, { [cls.active]: active })}
    >
      {label}
    </div>
  );
};
